import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import { Box, Typography } from '@mui/material';
import { styles } from './styles';

export const EmptyState = () => {
  return (
    <Box sx={styles.emptyStateContainer}>
      <CloudDownloadOutlinedIcon sx={styles.emptyStateIcon} />
      <Typography variant="caption" sx={styles.emptyStateText}>
        Your download history will appear here.
      </Typography>
    </Box>
  );
};
